import withSharedStyles from "../theme/Shared.style";

// Stacked rows separated by hairlines (cart, order details).
const withCustomStyles = withSharedStyles(theme => ({
  item: {
    "& + &": {
      boxShadow: `inset 0 1px 0 ${theme.tokens.color.line}`
    }
  }
}));

export default withCustomStyles;
